// Function to open the popup
function openPopup() {
    var popup = document.querySelector('.popup');
    if (popup) {
        popup.classList.add('open');
    }
}

// Function to close the popup
function closePopup() {
    var popup = document.querySelector('.popup');
    if (popup) {
        popup.classList.remove('open');
    }
}

// Event listener to open the popup when any element with class "openpopup" is clicked
var openPopupButtons = document.querySelectorAll('.openpopup');
openPopupButtons.forEach(function (button) {
  button.addEventListener('click', openPopup);
});

// Event listener to close the popup when the element with class "closepopup" is clicked
var closePopupButton = document.querySelector('.closepopup');
if (closePopupButton) {
  closePopupButton.addEventListener('click', closePopup);
}
